module.exports = function() { return __webpack_public_path__ + "add-guests.3pyTriNFK5BUBEd-qzK6.svg";};